import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "transaction-password-popup" }

import { ref, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n'
import CreatePassword from './CreatePassword.vue';
import ResetPassword from './ResetPassword.vue';
import BindMobile from '../BindMobile'
import { useUserStore } from '@/store';


export default {
  __name: 'index',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const MyDialog = inject('myDialog');

const { t } = useI18n()

const userStore = useUserStore()
const showBindMobile = ref(false)


// onMounted(() => {
//   // 未绑定手机号
//   if(!userStore.isNullPasswordTrade && !userStore.phone) {
//     MyDialog.confirm({
//       message: t('msg.beforeResetPassword'),
//     })
//     .then(() => {// on confirm
//       showBindMobile.value = true;
//     })
//     .catch(() => {
//       emit('onClose')
//     });
//   }
// })

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(userStore).isNullPasswordTrade)
      ? (_openBlock(), _createBlock(CreatePassword, {
          key: 0,
          onOnClose: _cache[0] || (_cache[0] = $event => (emit('onClose')))
        }))
      : (_openBlock(), _createBlock(ResetPassword, {
          key: 1,
          phone: _unref(userStore).phone || _unref(userStore).registerPhone,
          onOnClose: _cache[1] || (_cache[1] = $event => (emit('onClose')))
        }, null, 8, ["phone"]))
  ]))
}
}

}